"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
const BulkActions_vue_1 = __importDefault(require("./BulkActions.vue"));
const TableTrialSamplesTracking_vue_1 = __importDefault(require("./TableTrialSamplesTracking.vue"));
let ModalTrialsTracking = class ModalTrialsTracking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isDeployModal = true;
        this.toSearch = '';
        this.samplesFilter = [];
        this.codesSamplesCheck = [];
        this.multiCopyCodeSeparators = [',', '|', ' '];
    }
    get stateIdModal() {
        if (this.stateModal === 'pending_send' || this.stateModal === 'markSend') {
            return 1;
        }
        if (this.stateModal === 'at_lab')
            return 2;
        if (this.stateModal === 'pending_metadata')
            return 3;
        if (this.stateModal === 'analyzed')
            return 4;
    }
    get isActionMarkModal() {
        if (this.stateModal === 'markSend')
            return true;
        return false;
    }
    get isSubStateModal() {
        if (this.stateModal === 'pending_lab_but_sent' ||
            this.stateModal === 'analyzed') {
            return true;
        }
        else {
            return false;
        }
    }
    get isListSamplesActionModal() {
        if (this.stateModal !== 'pending_lab_but_sent' &&
            this.stateModal !== 'analyzed' &&
            this.stateModal !== 'markSend') {
            return true;
        }
        else {
            return false;
        }
    }
    markSamplesSent() {
        this.$emit('codesSamplesCheck', this.codesSamplesCheck);
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    codesSelect(codes) {
        this.codesSamplesCheck = codes;
    }
    onchangesearch(text) {
        this.toSearch = text;
        this.samplesFilter = this.samples;
        const patt = new RegExp(text);
        if (text.includes(',') || text.includes(' ') || text.includes('|')) {
            this.samplesFilter = [];
            const arrayCodes = text.split(/[\s,|]+/);
            for (const code of arrayCodes) {
                for (const sample of this.samples) {
                    if (code
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(sample.sample_code.toString().toLowerCase().trim())) {
                        this.samplesFilter.push(sample);
                    }
                }
            }
        }
        else {
            this.samplesFilter = this.samples.filter((sample) => {
                if (sample.sample_code
                    .toString()
                    .toLowerCase()
                    .trim()
                    .includes(text.toString().toLowerCase().trim()) ||
                    patt.test(sample.sample_code.toString().toLowerCase().trim())) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalTrialsTracking.prototype, "stateModal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ModalTrialsTracking.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ModalTrialsTracking.prototype, "responseMark", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ModalTrialsTracking.prototype, "loading", void 0);
ModalTrialsTracking = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            Search: bmk_ui_framework_1.Search,
            Save: lucide_vue_next_1.Save,
            Button: bmk_ui_framework_1.Button,
            BulkActions: BulkActions_vue_1.default,
            Toasts: bmk_ui_framework_1.Toasts,
            TableTrialSamplesTracking: TableTrialSamplesTracking_vue_1.default,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            ShipmentIcon: bmk_ui_framework_1.ShipmentIcon,
            Loading: bmk_ui_framework_1.Loading,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            ArrowLeftIcon: bmk_ui_framework_1.ArrowLeftIcon,
            Tag: bmk_ui_framework_1.Tag,
            Dropdown: floating_vue_1.Dropdown,
            HelpCircle: lucide_vue_next_1.HelpCircle,
        },
    })
], ModalTrialsTracking);
exports.default = ModalTrialsTracking;
